import React from "react";
import Form from "react-bootstrap/Form";

const SwSwitchButtons = ({
  id,
  label,
  checked,
  defaultChecked,
  onChange,
  disabled = false,
  size = "md",          // md | lg
  className = "",
  ...rest
}) => {
  return (
    <Form.Check
      type="switch"
      id={id}
      label={label}
      checked={checked}
      defaultChecked={defaultChecked}
      onChange={onChange}
      disabled={disabled}
      className={`sw-switch sw-switch-${size} ${className}`}
      {...rest}
    />
  );
};

export default SwSwitchButtons;
